import React from 'react';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import DefaultThumb from './Default';
import TierThumb from './Tier';
import type { MobileThumbProps } from './types';

const MobileThumb: React.FC<MobileThumbProps> = props => {
  const type = getDeviationType(props.deviation);
  switch (type) {
    case DeviationTypes.TIER:
      return <TierThumb {...props} />;
    default:
      return <DefaultThumb {...props} />;
  }
};
MobileThumb.displayName = 'MobileThumb';

export default MobileThumb;
